import { JSONView } from "@heliopolis/ui/JSONView.tsx";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import type { JSX } from "react";
import { useForm } from "react-hook-form";
import * as z from "zod";
import { EmailAddress } from "../iam/schemas.ts";
import { useORPC } from "../orpc-react.tsx";
import { Card } from "./Card.tsx";
import { ProgressIndicator } from "./ProgressIndicator.tsx";

const AuthenticationFormValues = z.object({
  recipientEmailAddress: EmailAddress,
});
interface AuthenticationFormValues extends z.output<typeof AuthenticationFormValues> {}

export default function AuthenticationForm(): JSX.Element {
  const orpc = useORPC();

  const requestLoginLink = useMutation(orpc.iam.requestLoginLink.mutationOptions());

  const {
    formState: { errors, isSubmitting },
    handleSubmit,
    register,
  } = useForm({
    resolver: zodResolver(AuthenticationFormValues),
  });

  const validateLoginLinkRequestFormAndSendRequest = handleSubmit((formValues) => {
    return requestLoginLink.mutateAsync(formValues);
  });

  return (
    <Card style={{ minWidth: "40rem" }}>
      <form onSubmit={validateLoginLinkRequestFormAndSendRequest}>
        <div className="form-control">
          <label htmlFor="name">Account name</label>
          <input
            {...register("recipientEmailAddress")}
            aria-describedby="recipient-email-address-validation-message"
            aria-invalid={errors?.recipientEmailAddress !== undefined ? true : undefined}
            aria-label="Email address"
            placeholder="myEmail@example.com"
            type="email"
            width="100%"
          />
          {errors?.recipientEmailAddress && (
            <small className="error" id="recipient-email-address-validation-message">
              {errors.recipientEmailAddress.message}
            </small>
          )}
        </div>
        <button aria-busy={isSubmitting} className="primary" disabled={isSubmitting} type="submit">
          Send me a login link!
        </button>
        {requestLoginLink.isPending && <ProgressIndicator />}
        {requestLoginLink.isError && <>{requestLoginLink.error.message}</>}
        {requestLoginLink.isSuccess && <JSONView data={requestLoginLink.data} />}
      </form>
    </Card>
  );
}
